// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type ToolListe, ToolStage } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export type SearchToolsQuery = {
  search?: string;
  stage?: ToolStage;
  mandantId?: string;
  page?: number;
  limit?: number;
  sort?: string;
};

export function useSearchTools(): (
  query: SearchToolsQuery
) => Promise<ToolListe> {
  const getAPI = useGetApi();
  return useCallback(
    async (query = {}) => (await getAPI()).tools.searchTools({ ...query }),
    [getAPI]
  );
}
